import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ChevronLeft, FileText, BookOpen } from "lucide-react";
import { RESOURCES } from "../data/resources";
import { RESOURCE_LONG_FORM } from "../data/resources-content";

export default function ResourceDetail() {
  const { id } = useParams();
  const r = RESOURCES.find((x) => x.id === id);
  if (!r) return <Navigate to="/resources" replace />;
  const long = RESOURCE_LONG_FORM[r.id] || { sections: [] };

  return (
    <>
      <section className="detail-hero">
        <div className="container">
          <div className="detail-hero-inner">
            <Link to="/resources" className="detail-back" data-testid="resource-back-link">
              <ChevronLeft size={14} /> All resources
            </Link>
            <div className="section-label"><span className="dot" />
              {r.type === 'whitepaper' ? <><FileText size={11} style={{ marginRight: 6, display: "inline" }} /> White paper</> : <><BookOpen size={11} style={{ marginRight: 6, display: "inline" }} /> Blog</>}
            </div>
            <h1 className="detail-hero-title" data-testid="resource-detail-h1">{r.title}</h1>
            <div className="resource-detail-meta">
              <span>{r.date}</span>
              <span>·</span>
              <span>{r.readTime}</span>
              <span>·</span>
              <span>{r.author}</span>
            </div>
            <p style={{ fontSize: 18, color: "var(--text-2)", maxWidth: 760, lineHeight: 1.6, marginTop: 16 }}>
              {r.excerpt}
            </p>
          </div>
        </div>
      </section>

      <section className="detail-body">
        <div className="container">
          <div className="resource-detail-body" data-testid="resource-detail-body">
            {long.sections.length === 0 && (
              <p>The full text of this resource will be published shortly. <Link to="/contact" style={{ color: "var(--steel)", textDecoration: "underline" }}>Request early access</Link>.</p>
            )}
            {long.sections.map((s, i) => (
              <div key={i}>
                <h3>{s.h}</h3>
                <p>{s.body}</p>
              </div>
            ))}
            <p style={{ marginTop: 40, padding: 24, background: "var(--bg-sunk)", borderLeft: "3px solid var(--steel)", borderRadius: 8 }}>
              Want to apply these ideas to your active portfolio?
              {" "}<Link to="/contact" style={{ color: "var(--steel)", fontWeight: 600 }}>Book a 30-min walkthrough →</Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
